import React, { useState, useEffect, useRef } from "react";
import { FiThumbsUp } from "react-icons/fi";
import { BiErrorCircle } from "react-icons/bi";
import { changePassword } from "../Auth";
import {
  Alert,
  Button,
  Card,
  Col,
  Row,
  Spinner
} from "react-bootstrap";
import ChangePasswordModal from './ChangePasswordModal';

const formatDateTime = (value) => {
  if (!value) return 'First login';
  const d = new Date(value);
  if (isNaN(d.getTime())) return String(value);
  return d.toLocaleString('en-US');
};

const UserPanel = (props) => {
  const [showModal, setShowModal] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [fetchingData, setFetchingData] = useState(true);
  const username = useRef('');

  useEffect(() => {
    if (props.user) {
      setFetchingData(true);
      username.current = props.user.email;
      setFetchingData(false);
    }
  }, [props.user]);

  const changePasswordHandler = async (oldPass, newPass, confirmPass) => {
    try {
      setError(false);
      setSuccess(false);

      if (newPass === confirmPass) {
        setFetchingData(true);
        await changePassword(oldPass, newPass);
        setFetchingData(false);
        setSuccess(true);
      } else {
        setError(true);
        setErrorMsg("New and confirm password fields do not match.");
      }
    } catch (e) {
      setFetchingData(false);
      setError(true);
      // ApiError carries the server's structured error envelope on `.body`;
      // surface the backend message (e.g. "Current password is incorrect")
      // rather than the generic "POST ... failed: 400".
      setErrorMsg(e?.body?.error || e?.message || "Failed to change password.");
    }
  };

  return (
    <Card className="shadow-sm widget-card text-left">
      {fetchingData ? (
        <Card.Body className="d-flex justify-content-center">
          <Spinner animation="border" variant="primary" />
        </Card.Body>
      ) : (
        <div>
          <Card.Body>
            <Row>
              <Col className="pl-4 pr-4">
                {error && (
                  <Alert variant="danger" className="text-center">
                    <BiErrorCircle className="mr-2" />
                    Error: {errorMsg}
                  </Alert>
                )}
                {success && (
                  <Alert variant="success" className="text-center">
                    <FiThumbsUp className="mr-2" />
                    Successfully changed password
                  </Alert>
                )}
                <div className="mb-4">
                  <small>Username</small>
                  <p style={{ fontSize: '13px' }}>{username.current}</p>
                  <small>Last login</small>
                  <p style={{ fontSize: '13px' }}>{formatDateTime(props.user?.lastLoginAt)}</p>
                </div>
                <ChangePasswordModal
                  show={showModal}
                  setShow={(value) => setShowModal(value)}
                  changePasswordHandler={async (oldPass, newPass, confirmPass) =>
                    await changePasswordHandler(oldPass, newPass, confirmPass)
                  }
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <Button onClick={() => setShowModal(!showModal)} variant="primary">
                  Change Password
                </Button>
              </Col>
            </Row>
          </Card.Body>
        </div>
      )}
    </Card>
  );
};

export default UserPanel;
